import { render, staticRenderFns } from "./LbaLocaleEdit.vue?vue&type=template&id=26d30b2b"
import script from "./LbaLocaleEdit.vue?vue&type=script&lang=js"
export * from "./LbaLocaleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports